<!--
 * @FilePath: /eshop-ops-web/src/views/goodsManage/baseDepot/details.vue
 * @Description: 
 * @Author: xiexingzhong2012@sina.cn
 * @Date: 2023-07-24 17:09:29
 * @LastEditTime: 2023-07-30 11:15:47
 * @LastEditors: xiexingzhong2012@sina.cn
-->
<template>
  <div class="comContent">
    <div class="firstTopic text-left mb20 header">{{ title }}</div>
    <div>
      <goodsInfo ref="goodsInfoRef" @submit-goods="submit" @overwritesubmit-goods="overwritesubmit" @secondsubmit-goods="secondsubmit" @back="goBack"
        @reject-goods="rejectGoods" :pageType="pageType" />
    </div>
    <el-backtop target=".comContent" :bottom="60"></el-backtop>
  </div>
</template>
<script>
// addGsoodsbase
import {
  addGsoodsbase,
  updateCompGoodsBaseDetail,
  goodsTemporaryReject,
} from "@/api/goodsManage/baseDepot.js";
import goodsInfo from "./components/goodsInfo.vue";

export default {
  components: { goodsInfo },
  data() {
    return {
      title: "商品详情",
      pageType: 1, //pageType 1商品基库-》 查看  2商品基库-》 编辑（操作：保存提交，返回）  3商品基库-》 创建 （操作：保存提交，返回）     4  商家申请-》详情 （操作：创建，驳回） 5 商家申请-》创建商品基础库 （操作：保存提交，返回）
    };
  },
  filters: {},
  created() { },
  watch: {
    // 路由发生变化页面刷新
    $route(to, from) {
      // 在created、mounted函数执行的方法，放到该处再执行一次
      this.init();
    },
  },
  mounted() {
    const { pageType, status } = this.$route.query;
    if (pageType != undefined) {
      this.pageType = pageType;
    }
  },
  methods: {
    init() {
      this.pageType = this.$route.query.pageType;
    },

    /**
     * @description: 保存商品详情
     * @return {*}
     */
    saveGoodsDetail(params) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      addGsoodsbase(params)
        .then((res) => {
          setTimeout(() => {
            loading.close();
          }, 1000);
          if (res && res.code == 0) {
            setTimeout(() => {
              this.$message({
                message: `提交成功！`,
                type: "success",
              });
              this.$refs.goodsInfoRef.handelSetId(res.data)
              if (this.pageType == 4 || this.pageType == 5) {
                this.backAndCloseTab()
              }  
            }, 2000);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            loading.close();
          }, 1000);
          this.$message({
            message: `${err}`,
            type: "error",
          });
        });
    },

    /**
     * @functionName: updateCompGoodsBaseDetail
     * @description: 修改商品详情
     * @return {*}
     */

    editGoodsDetail(params) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      updateCompGoodsBaseDetail({
        ...params,
      }).then((res) => {
        setTimeout(() => {
            loading.close();
          }, 1000);
        if (res && res.code == 0) {
          setTimeout(() => {
            this.$message({
              message: `提交成功！`,
              type: "success",
            }); 
            if (this.pageType == 4 || this.pageType == 5) {
                this.backAndCloseTab()
            }  
          }, 2000);
        }
      }).catch((err) => {
          setTimeout(() => {
            loading.close();
          }, 1000);
          this.$message({
            message: `${err}`,
            type: "error",
          });
        });;
    },

    // 提交按钮
    submit(params) {
      if (params.id != undefined && this.pageType != 5) {
        // 保存提交
        params['submitType'] = 0
        this.editGoodsDetail(params);
      } else {
        if (params.id) {
          delete params.id;
        }
        this.saveGoodsDetail(params);
      }
    },
    overwritesubmit(params) {
      // 完善保存
      params['submitType'] = 1
      this.editGoodsDetail(params);
    },
    secondsubmit(params){
      // 二审
      params['submitType'] = 2
      this.editGoodsDetail(params);
    },
    // goBack 返回
    goBack() {
      let activeName = "1";
      if (this.pageType == 4 || this.pageType == 5) {
        activeName = "2";
      }

      if (this.pageType == 2 || this.pageType == 3 || this.pageType == 5) {
        this.$confirm(
          "未保存的内容将会丢失，请问是否确认返回上一级？",
          "返回上一级",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => { 
            this.backAndCloseTab() 
          })
          .catch(() => { });
      } else {
        this.backAndCloseTab()
      }
    },
    backAndCloseTab() {
      if (this.pageType == 4 || this.pageType == 5) {
        this.$router.back(-1)
      } else {
        window.close()
      } 
    },
    submitBack() {
      let activeName = "1";
      if (this.pageType == 4 || this.pageType == 5) {
        activeName = "2";
      }
      // this.$router.push(
      //   "./goodsManage-baseDepot-index?activeName=" + activeName
      // );
    },

    // 商家申请驳回
    rejectGoods(params) {
      goodsTemporaryReject(params).then((res) => {
        this.$message({
          message: `提交成功！`,
          type: "success",
        });
        // this.$router.push(
        //   "./goodsManage-baseDepot-index?activeName=" + activeName
        // );
        this.$router.back(-1)
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./styles/index.scss");
</style>
